import Lenis from 'lenis'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

let instance = null
let rafCallback = null

export const createLenis = () => {
  if (instance) return instance

  instance = new Lenis({
    smoothWheel: true,
    syncTouch: false,
  })

  instance.on('scroll', ScrollTrigger.update)

  rafCallback = (time) => instance.raf(time * 1000)
  gsap.ticker.add(rafCallback)
  gsap.ticker.lagSmoothing(0)

  return instance
}

export const getLenis = () => instance

export const destroyLenis = () => {
  if (!instance) return
  if (rafCallback) {
    gsap.ticker.remove(rafCallback)
    rafCallback = null
  }
  instance.destroy()
  instance = null
}
